// extracted by mini-css-extract-plugin
export var container = "footer-module--container--5GliC";
export var company = "footer-module--company--GoGno";
export var logo = "footer-module--logo--Yt86o";
export var links = "footer-module--links--LTQh5";
export var copylight = "footer-module--copylight--Y6pt-";
export var fixedButton = "footer-module--fixedButton--hxzRq";
export var footer_scrolled = "footer-module--footer_scrolled--Irk19";